export function importIntlPluralRulesLocaleData(locale: string) {
  switch (locale) {
    case 'de':
      return import(
        '@formatjs/intl-pluralrules/locale-data/de' /* webpackChunkName: 'intl-pluralrules-locale-data-de' */
      );

    case 'ja':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ja' /* webpackChunkName: 'intl-pluralrules-locale-data-ja' */
      );

    case 'es':
    case 'es-mx':
      return import(
        '@formatjs/intl-pluralrules/locale-data/es' /* webpackChunkName: 'intl-pluralrules-locale-data-es' */
      );

    case 'id':
      return import(
        '@formatjs/intl-pluralrules/locale-data/id' /* webpackChunkName: 'intl-pluralrules-locale-data-id' */
      );

    case 'ko':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ko' /* webpackChunkName: 'intl-pluralrules-locale-data-ko' */
      );

    case 'ms':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ms' /* webpackChunkName: 'intl-pluralrules-locale-data-ms' */
      );

    case 'ru':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ru' /* webpackChunkName: 'intl-pluralrules-locale-data-ru' */
      );

    case 'th':
      return import(
        '@formatjs/intl-pluralrules/locale-data/th' /* webpackChunkName: 'intl-pluralrules-locale-data-th' */
      );

    case 'tr':
      return import(
        '@formatjs/intl-pluralrules/locale-data/tr' /* webpackChunkName: 'intl-pluralrules-locale-data-tr' */
      );

    case 'uk':
      return import(
        '@formatjs/intl-pluralrules/locale-data/uk' /* webpackChunkName: 'intl-pluralrules-locale-data-uk' */
      );

    case 'vi':
      return import(
        '@formatjs/intl-pluralrules/locale-data/vi' /* webpackChunkName: 'intl-pluralrules-locale-data-vi' */
      );

    case 'da':
      return import(
        '@formatjs/intl-pluralrules/locale-data/da' /* webpackChunkName: 'intl-pluralrules-locale-data-da' */
      );

    case 'fr':
      return import(
        '@formatjs/intl-pluralrules/locale-data/fr' /* webpackChunkName: 'intl-pluralrules-locale-data-fr' */
      );

    case 'it':
      return import(
        '@formatjs/intl-pluralrules/locale-data/it' /* webpackChunkName: 'intl-pluralrules-locale-data-it' */
      );

    case 'nl':
      return import(
        '@formatjs/intl-pluralrules/locale-data/nl' /* webpackChunkName: 'intl-pluralrules-locale-data-nl' */
      );

    case 'pl':
      return import(
        '@formatjs/intl-pluralrules/locale-data/pl' /* webpackChunkName: 'intl-pluralrules-locale-data-pl' */
      );

    case 'pt':
    case 'pt-br':
      return import(
        '@formatjs/intl-pluralrules/locale-data/pt' /* webpackChunkName: 'intl-pluralrules-locale-data-pt' */
      );

    case 'sv':
      return import(
        '@formatjs/intl-pluralrules/locale-data/sv' /* webpackChunkName: 'intl-pluralrules-locale-data-sv' */
      );

    case 'fi':
      return import(
        '@formatjs/intl-pluralrules/locale-data/fi' /* webpackChunkName: 'intl-pluralrules-locale-data-fi' */
      );

    case 'cs':
      return import(
        '@formatjs/intl-pluralrules/locale-data/cs' /* webpackChunkName: 'intl-pluralrules-locale-data-cs' */
      );

    case 'bg':
      return import(
        '@formatjs/intl-pluralrules/locale-data/bg' /* webpackChunkName: 'intl-pluralrules-locale-data-bg' */
      );

    case 'ca':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ca' /* webpackChunkName: 'intl-pluralrules-locale-data-ca' */
      );

    case 'hr':
      return import(
        '@formatjs/intl-pluralrules/locale-data/hr' /* webpackChunkName: 'intl-pluralrules-locale-data-hr' */
      );

    case 'et':
      return import(
        '@formatjs/intl-pluralrules/locale-data/et' /* webpackChunkName: 'intl-pluralrules-locale-data-et' */
      );

    case 'el':
      return import(
        '@formatjs/intl-pluralrules/locale-data/el' /* webpackChunkName: 'intl-pluralrules-locale-data-el' */
      );

    case 'hu':
      return import(
        '@formatjs/intl-pluralrules/locale-data/hu' /* webpackChunkName: 'intl-pluralrules-locale-data-hu' */
      );

    case 'lv':
      return import(
        '@formatjs/intl-pluralrules/locale-data/lv' /* webpackChunkName: 'intl-pluralrules-locale-data-lv' */
      );

    case 'lt':
      return import(
        '@formatjs/intl-pluralrules/locale-data/lt' /* webpackChunkName: 'intl-pluralrules-locale-data-lt' */
      );

    case 'ro':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ro' /* webpackChunkName: 'intl-pluralrules-locale-data-ro' */
      );

    case 'sr':
      return import(
        '@formatjs/intl-pluralrules/locale-data/sr' /* webpackChunkName: 'intl-pluralrules-locale-data-sr' */
      );

    case 'sk':
      return import(
        '@formatjs/intl-pluralrules/locale-data/sk' /* webpackChunkName: 'intl-pluralrules-locale-data-sk' */
      );

    case 'sl':
      return import(
        '@formatjs/intl-pluralrules/locale-data/sl' /* webpackChunkName: 'intl-pluralrules-locale-data-sl' */
      );

    case 'sw':
      return import(
        '@formatjs/intl-pluralrules/locale-data/sw' /* webpackChunkName: 'intl-pluralrules-locale-data-sw' */
      );

    case 'is':
      return import(
        '@formatjs/intl-pluralrules/locale-data/is' /* webpackChunkName: 'intl-pluralrules-locale-data-is' */
      );

    case 'fil':
      return import(
        '@formatjs/intl-pluralrules/locale-data/fil' /* webpackChunkName: 'intl-pluralrules-locale-data-fil' */
      );

    case 'ar':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ar' /* webpackChunkName: 'intl-pluralrules-locale-data-ar' */
      );

    case 'he':
      return import(
        '@formatjs/intl-pluralrules/locale-data/he' /* webpackChunkName: 'intl-pluralrules-locale-data-he' */
      );

    case 'mt':
      return import(
        '@formatjs/intl-pluralrules/locale-data/mt' /* webpackChunkName: 'intl-pluralrules-locale-data-mt' */
      );

    case 'az':
      return import(
        '@formatjs/intl-pluralrules/locale-data/az' /* webpackChunkName: 'intl-pluralrules-locale-data-az' */
      );

    case 'ka':
      return import(
        '@formatjs/intl-pluralrules/locale-data/ka' /* webpackChunkName: 'intl-pluralrules-locale-data-ka' */
      );

    case 'gl':
      return import(
        '@formatjs/intl-pluralrules/locale-data/gl' /* webpackChunkName: 'intl-pluralrules-locale-data-gl' */
      );

    case 'eu':
      return import(
        '@formatjs/intl-pluralrules/locale-data/eu' /* webpackChunkName: 'intl-pluralrules-locale-data-eu' */
      );

    case 'fr-ca':
      return import(
        '@formatjs/intl-pluralrules/locale-data/fr' /* webpackChunkName: 'intl-pluralrules-locale-data-fr' */
      );

    case 'zh-hant':
    case 'zh-hans':
      return import(
        '@formatjs/intl-pluralrules/locale-data/zh' /* webpackChunkName: 'intl-pluralrules-locale-data-zh' */
      );

    case 'no':
      // Norwegian bokmål (nb) is the dominant language in Norway
      return import(
        '@formatjs/intl-pluralrules/locale-data/nb' /* webpackChunkName: 'intl-pluralrules-locale-data-nb' */
      );

    default:
      return import(
        '@formatjs/intl-pluralrules/locale-data/en' /* webpackChunkName: 'intl-pluralrules-locale-data-en' */
      );
  }
}
